'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SvgIcon = require('../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _styled = require('./styled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Icon = function Icon(_ref) {
  var color = _ref.color,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, ['color', 'name']);

  return _react2.default.createElement(
    _styled.Icon,
    _extends({ color: color }, rest),
    _react2.default.createElement(_SvgIcon2.default, { name: name })
  );
};

Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired
} : {};

exports.default = Icon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Alert/Icon.js
// module id = 2198
// module chunks = 14